import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import _ from 'lodash';
import {moment} from '../../../../../js/globals';
import { ClientLoggerService } from '../../../../services/client-logger.service';
import { MySynchEnumerationService } from '../../../../services/mysynch.enumeration.service';
import { PerformanceMetricsService } from '../../../../services/performance-metrics.service';
import { PerformanceContextService } from '../../../../services/performance-context.service';
import { DeviceDetectorService } from 'ngx-device-detector';

import { ParnellEnum,PerformanceContext } from '../../../../interfaces/mysynch.interfaces';
interface InActiveFarmRow {
    farmId: number;
    name: string;
    location: string;
    admin: string;
    status:number;
    adminEmail: string;
    adminCell: string; 
    originalStatus: number;
    lastEventDate: string | null;
    lastEventDateDisplay: string;
    lastEventDateHighlightColor: string;
}
@Component({
    standalone: false,
    selector: 'tm-inactive-farms-view',
    templateUrl: '../app/pages/tm-dashboard/views/tm-inactive-farms-view/tm-inactive-farms-view.view.html',
    styleUrls: ['../app/pages/tm-dashboard/views/tm-inactive-farms-view/tm-inactive-farms-view.style.css']
    })
export class TMInactiveFarmsView implements OnInit , OnDestroy{
    
    private performanceContext: PerformanceContext | null = null;
    private editFarmStateName:string = "FarmManagementMaint";
    private extraDisplayProperties:string[] = ['lastEventDateDisplay','lastEventDateHighlightColor'];
    private tmDashboardSiteConfig:any = {};

    private farmStatuses: ParnellEnum[] = []; 
    private pendingValue:number = 0;
    private pendingText:string = "";

    isMobile:boolean = false;
    loading:boolean = true;
    _: any = _;

    farms: InActiveFarmRow[] = [];
    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject('CookieFactory') private cookies:any,
                @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
                @Inject(ClientLoggerService) private log:ClientLoggerService
                ){
                    this.isMobile = this.deviceDetector.isMobile();
                    this.farmStatuses =_.reject(_.values(this.mySynchEnumSvc.getMySynchEnumerationItems("PersonRoleStatus")), (i) => {
                                    return i.name === 'PENDING';
                                });
                    this.pendingValue = _.get(this.mySynchEnumSvc.getMySynchEnumeration('FarmStatus','PENDING'),'value');
                    this.pendingText  = _.get(this.mySynchEnumSvc.getMySynchEnumeration('FarmStatus','PENDING'),'text');
                }

    ngOnInit() {
        this.MSF.ready(() => {
           const cfTMDashboardConfig = _.find(_.get(this.MSF,'lists.codeFile',[]),{codeType: "SITECONFIGS",code: "TMDASHBOARD"});
				
            if(!_.isUndefined(cfTMDashboardConfig)){
                this.tmDashboardSiteConfig = _.cloneDeep(cfTMDashboardConfig);
                const detailsJson = this.MSF.safeGetParsedJson( _.get(this.tmDashboardSiteConfig,'detailsJson','{}'));
                if(!_.isEmpty(detailsJson)){
                    _.set(this.tmDashboardSiteConfig,'detailsJson',detailsJson[0]);
                   // this.tmDashboardSiteConfig = this.tmDashboardSiteConfig;
                }
            }	
            this.performanceContext = this.perfContextSvc.createPerformanceContext();
            this.perfMetricSvc.startTiming("Page:TerritoryManagementDashboardInactiveFarms:Render");
            this.refresh().then(() => {
                this.perfMetricSvc.markPageReady("Page:TerritoryManagementDashboardInactiveFarms:Render", this.performanceContext);
            });
        });
    }

    ngOnDestroy() {
        this.performanceContext = null;
    }
    editFarm(farm: InActiveFarmRow){

        this.MSF.loadPage(this.editFarmStateName,{farmId: farm.farmId, tmDashSelectedTabName: "inactive-farms"});
    }

    /**
     *  Function that gets the date format for the Connection Date Column
     * 	@param {string} dateString - date string of the CowEventsMeta.LastEventDate
     *  @returns formatted string version of CowEventsMeta.LastEventDate or empty string if dateString is null
     */
    private getFormattedConnectionDate(dateString: string): string{
        if(_.isNull(dateString)){
            return "";
        }
        
        
        var formattedDateString = moment(dateString).format(this.MSF.i18n.format.dateMedium);
        return formattedDateString;
    }
    /**
     * Function that gets the highlight color for the Connection Date Column based on the date and the highlight color cutoffs
     * @param {string} dateString - date string of the CowEventsMeta.LastEventDate
     * @returns (string) css highlight color for the Connection Date Column
     */
    private getHighlightColor(dateString: string): string{
        if(_.isNull(dateString)){
            return "";
        }
        
        var date = moment(dateString);
        var now = moment();
        var daysSinceLastEvent = now.diff(date,'days');
        var highlightColor = "none";
        var connectionDateHighlightCutoffs = _.get(this.tmDashboardSiteConfig,'detailsJson.connectionDateHighlightCutoffs',[]);
        
        _.forEach(connectionDateHighlightCutoffs,(cutoff) => {
            var minNumDaysOld = _.get(cutoff,'minNumDaysOld',0);
            var maxNumDaysOld = _.get(cutoff,'maxNumDaysOld',0);
            if(daysSinceLastEvent >= minNumDaysOld && daysSinceLastEvent < maxNumDaysOld){
                highlightColor = _.get(cutoff,'highlightColor',"none");
            }
        });
        return highlightColor;
    }

    private refresh() {
       return new Promise<void>((resolve, reject) => {
            this.loading = true;
            this.farms = [];

            this.perfMetricSvc.startTiming("Page:TerritoryManagementDashboardInactiveFarms:Request");
            this.api.getAllInactiveFarmsForTerritoryDashboard(this.cookies.user.PersonId, this.performanceContext, (err:any, data:any) => {
                this.perfMetricSvc.endTiming("page","Page:TerritoryManagementDashboardInactiveFarms:Request", this.performanceContext);
                this.perfMetricSvc.startTiming("Page:TerritoryManagementDashboardInactiveFarms:Build");
                this.loading = false;

                if (err) {
                    this.log.error(this.MSF.notify.danger('unable to get farms: ' + err));
                    this.farms = [];
                    resolve();
                    this.perfMetricSvc.endTiming("page","Page:TerritoryManagementDashboardInactiveFarms:Build", this.performanceContext);
                    return;
                }

                this.farms = _.map(data, (row:InActiveFarmRow) => {
                    row.originalStatus = row.status;

                    var lastEventDate = _.get(row,'lastEventDate',"");
                    // dateString isn't in UTC. So we want to remove the Z from the end of the string
                    if(_.includes(lastEventDate,'Z')){
                        lastEventDate = lastEventDate.slice(0,-1);
                    }

                    if(_.isEmpty(lastEventDate)){
                        var inactiveFarmNoDateText = _.get(this.tmDashboardSiteConfig,'detailsJson.inactiveFarmNoDateText',"");
                        var inactiveFarmNoDateHighlightColor = _.get(this.tmDashboardSiteConfig,'detailsJson.inactiveFarmNoDateHighlightColor',"");

                        _.set(row,'lastEventDateDisplay',inactiveFarmNoDateText);
                        _.set(row,'lastEventDateHighlightColor',inactiveFarmNoDateHighlightColor);
                    }else{
                        _.set(row,'lastEventDate',lastEventDate);
                        _.set(row,'lastEventDateDisplay',this.getFormattedConnectionDate(lastEventDate))
                        _.set(row,'lastEventDateHighlightColor',this.getHighlightColor(lastEventDate));
                    }


                    return row;
                });
                resolve();
                this.perfMetricSvc.endTiming("page","Page:TerritoryManagementDashboardInactiveFarms:Build", this.performanceContext);
            });
        });
    }
}